var ezdia;
(function (ezdia) {
    var mainTemplate = function (context) {
        var e_1, _a;
        var steps = context.steps, index = context.index;
        var stepsItem = '';
        var count = 0;
        try {
            for (var steps_1 = __values(steps), steps_1_1 = steps_1.next(); !steps_1_1.done; steps_1_1 = steps_1.next()) {
                var stepItem = steps_1_1.value;
                var name_1 = stepItem.name, label = stepItem.label;
                stepsItem += "<div id=\"ez-steps-" + name_1 + "\" class=\"ez-step-block col-md-3 " + (count === index ? "step-active" : '') + "\">\n        <label class=\"img-circle step-count\"><span>" + (count + 1) + "</span><i class=\"fa fa-check\"></i></label>\n        <label class=\"step-text\">" + label + "</label>\n      </div>";
                count += 1;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (steps_1_1 && !steps_1_1.done && (_a = steps_1.return)) _a.call(steps_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var ret = "<div class=\"row ez-steps\">" + stepsItem + "</div>";
        return ret;
    };
    var stepBrief = function (context) {
        var href = context.href, briefname = context.briefname, bodyId = context.bodyId, content = context.content;
        var ret = "<div class=\"panel ez-form-fields-grp ez-steps-brief-panel\">\n      <div class=\"panel-heading\" data-toggle=\"collapse\" href=\"" + href + "\">\n        <i class=\"fa fa-angle-up\"></i> " + briefname + "\n      </div>\n      <div id=\"" + bodyId + "\" class=\"panel-body collapse in\">" + content + "</div>\n    </div>";
        return ret;
    };
    var stepReviewFields = function (context) {
        var e_2, _a;
        var ret = '';
        try {
            for (var context_1 = __values(context), context_1_1 = context_1.next(); !context_1_1.done; context_1_1 = context_1.next()) {
                var col = context_1_1.value;
                var name_2 = col.name, column = col.column;
                ret += "<div class=\"form-group\">\n        <label class=\"control-label\" id=\"" + name_2 + "_label\">" + column.label + "</label>\n        <div class=\"inputs\">\n          <div class=\"form-control-static\">" + $.ezdia.inputs.readonlyView(col) + "</div>\n        </div>\n      </div>";
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (context_1_1 && !context_1_1.done && (_a = context_1.return)) _a.call(context_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return ret;
    };
    var stepReview = function (context) {
        var href = context.href, bodyId = context.bodyId, panelId = context.panelId, label = context.label, fileds = context.fileds, index = context.index;
        var ret = "<div id=\"" + panelId + "\"  class=\"panel ez-form-fields-grp\">\n      <div class=\"panel-heading\" data-toggle=\"collapse\" href=\"" + href + "\">\n        <i class=\"fa fa-angle-up\"></i> " + label + "\n        <a class=\"btn-circle btn-circle-sm btn-default pull-right\" data-index=\"" + index + "\" data-action=\"edit\"><i class=\"fa fa-pencil\"></i></a>\n      </div>\n      <div id=\"" + bodyId + "\" class=\"panel-body collapse in\">" + stepReviewFields(fileds) + "</div>\n    </div>";
        return ret;
    };
    var actionsButton = function (actions, name) {
        var e_3, _a;
        var ret = '';
        try {
            for (var actions_1 = __values(actions), actions_1_1 = actions_1.next(); !actions_1_1.done; actions_1_1 = actions_1.next()) {
                var action = actions_1_1.value;
                var type = action.type, classes = action.classes, label = action.label;
                ret += "<button type=\"button\"\n        data-step-action-btn=\"" + type + "\"\n        class=\"btn btn-success " + classes + "\"\n        id=\"ez-js-step-" + type + "-" + name + "\">\n        " + label + "\n      </button>";
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (actions_1_1 && !actions_1_1.done && (_a = actions_1.return)) _a.call(actions_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return ret;
    };
    var stepWrapper = function (context) {
        var ids = context.ids, classes = context.classes, cancel = context.cancel, name = context.name, back = context.back, actions = context.actions;
        var id = ids.id, heading = ids.heading, body = ids.body, footer = ids.footer, footerLeft = ids.footer__left, footerCenter = ids.footer__center, footerRight = ids.footer__right;
        var ret = "<div id=\"" + id + "\" class=\"clearfix ez-step-container " + classes + "\">\n      <div id=\"" + heading + "\" class=\"clearfix\"></div>\n      <div id=\"" + body + "\" class=\"clearfix\"></div>\n      <div id=\"" + footer + "\" class=\"ez-step-footer-block clearfix\">\n        <div class=\"container\">\n          <div class=\"row\">\n            <div id=\"" + footerLeft + "\" class=\"col-md-4 col-sm-4\">\n              " + (back
            ? "<button data-step-action-btn=\"back\" type=\"button\" class=\"btn btn-link\" id=\"ez-js-step-back-" + name + "\">\n                <i class=\"fa fa-angle-left\"></i> Back\n              </button>"
            : '') + "\n            </div>\n            <div id=\"" + footerCenter + "\" class=\"col-md-4 col-sm-4 text-center\"></div>\n            <div id=\"" + footerRight + "\" class=\"col-md-4 col-sm-4 text-right\">\n              " + (cancel
            ? "<button type=\"button\" data-step-action-btn=\"cancel\" class=\"btn btn-link\" id=\"ez-js-step-cancel-" + name + "\">Cancel</button>"
            : '') + "\n              " + actionsButton(actions, name) + "\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>";
        return ret;
    };
    var templates;
    (function (templates) {
        templates.steps = {
            mainTemplate: mainTemplate,
            stepBrief: stepBrief,
            stepReview: stepReview,
            stepWrapper: stepWrapper
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
